<template>
  <div>
    <div class="card-form">
      <div class="text-center mb-6">
        You choose to donate
        <b
          >{{ donation.currency.symbol }}
          <span v-if="donation.tip != 1">{{ donation.amount }}</span>
          <span v-else>{{ (donation.amount * 1.05).toFixed(1) }}</span></b
        >
        by
        <span v-if="selectedMethod === 'applePay'"
          ><i class="fab fa-apple"></i> Apple Pay</span
        >
        <span v-else-if="selectedMethod === 'googlePay'"
          ><i class="fab fa-google"></i> Google Pay</span
        >
        <span v-else>Apple/Google Pay</span>
        <span v-if="donation.monthly == 1">monthly</span>
        <span v-else>one time</span>
        &nbsp;
        <a
          class="small text-muted"
          href="#"
          @click.prevent="$emit('change-mode')"
          >Change</a
        >
      </div>

      <div>
        <div class="vertical-input-group">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Full name"
              v-model="donation.cardName"
              autocomplete="off"
            />
          </div>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="donation.cardEmail"
              placeholder="Your email"
            />
          </div>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="donation.address"
              placeholder="Your Address"
            />
          </div>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="donation.city"
              placeholder="Your City"
            />
            <input
              type="text"
              class="form-control"
              v-model="donation.zip"
              :placeholder="$store.state.country == 'us' ? 'ZIP' : 'Postal'"
            />
          </div>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="donation.state"
              :placeholder="
                $store.state.country == 'us' ? 'Your State' : 'Your Province'
              "
            />
            <select class="form-control" v-model="donation.country_id">
              <option value disabled selected>Select your country</option>
              <option
                v-for="country in countries"
                v-bind:value="country.id"
                v-bind:key="country.id"
              >
                {{ country.name }}
              </option>
            </select>
          </div>
        </div>

        <!-- Stripe Express Checkout Element (Apple Pay / Google Pay buttons) -->
        <div class="wallet-button-wrapper mt-3">
          <div ref="walletPrButton" class="wallet-pr-button"></div>
          <div
            v-if="!isFormValid"
            class="wallet-button-overlay"
            @click="showValidationMessage"
          ></div>
        </div>
        <div
          v-if="showValidationWarning"
          class="alert alert-warning mt-2 mb-0 py-2 px-3 small"
          role="alert"
        >
          Please enter your full name and a valid email before paying.
        </div>

        <div
          class="alert alert-danger mt-2 mb-0 py-2 px-3 small"
          role="alert"
          v-if="walletPayError"
        >
          {{ walletPayError }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    organization: {},
    donation: {},
    walletPayError: { default: "" },
    selectedMethod: { default: "" },
    stripeEce: { default: null },
  },
  data() {
    return {
      countries: [],
      showValidationWarning: false,
    };
  },
  computed: {
    isFormValid() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return (
        this.donation.cardName &&
        this.donation.cardName.trim().length > 0 &&
        this.donation.cardEmail &&
        emailRegex.test(this.donation.cardEmail)
      );
    },
  },
  watch: {
    stripeEce(ece) {
      if (ece && this.$refs.walletPrButton) {
        this.$nextTick(() => {
          try {
            ece.mount(this.$refs.walletPrButton);
          } catch (e) {
            console.error("[WalletPayForm] ECE watch-mount error:", e);
          }
        });
      }
    },
  },
  methods: {
    showValidationMessage() {
      this.showValidationWarning = true;
      setTimeout(() => {
        this.showValidationWarning = false;
      }, 3000);
    },
  },
  mounted() {
    let self = this;
    this.$nextTick(function () {
      var el = document.getElementById("payment-card");
      if (el) el.scrollIntoView();
      // Mount the Stripe Express Checkout Element now that the DOM is ready
      if (self.stripeEce && self.$refs.walletPrButton) {
        try {
          self.stripeEce.mount(self.$refs.walletPrButton);
        } catch (e) {
          console.error("[WalletPayForm] ECE mount error:", e);
        }
      }
    });
    this.axios
      .get(window.API_URL + "countries")
      .then(function (response) {
        self.countries = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  beforeDestroy() {
    if (this.stripeEce) {
      try {
        this.stripeEce.unmount();
      } catch (e) {}
    }
  },
};
</script>
<style lang="scss">
.wallet-pr-button {
  width: 100%;
  height: 48px;
}
.wallet-pr-button > *,
.wallet-pr-button iframe {
  width: 100% !important;
  height: 48px !important;
}
.wallet-button-wrapper {
  position: relative;
  min-height: 48px;
}
.wallet-button-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: not-allowed;
  z-index: 10;
  border-radius: 4px;
  background: transparent;
}
</style>
